import { render, staticRenderFns } from "./AddKrUpdate.vue?vue&type=template&id=5347ca7e&"
import script from "./AddKrUpdate.vue?vue&type=script&lang=js&"
export * from "./AddKrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports